const jsonSchema = [
  {
    type: 'group',
    fields: [
      {
        name: 'mailUsername',
        label: 'SMTP Username',
        type: 'text',
        showInList: true,
        required: true
      },
      {
        name: 'mailPassword',
        label: 'SMTP Password',
        type: 'text',
        required: true,
        showInList: true
      }
    ]
  },
  {
    type: 'group',
    fields: [
      {
        name: 'mailSmtpHost',
        label: 'mail.smtp.host',
        type: 'text',
        showInList: true,
        required: true
      },
      {
        name: 'mailSmtpPort',
        label: 'mail.smtp.port',
        type: 'text',
        required: true,
        showInList: true
      }
    ]
  },
  {
    type: 'group',
    fields: [
      {
        name: 'mailSmtpAuth',
        label: 'mail.smtp.auth',
        type: 'checkbox',
        showInList: true,
        required: true
      },
      {
        name: 'mailSmtpStarttlsEnable',
        label: 'mail.smtp.starttls.enable',
        type: 'checkbox'
      },
      {
        name: 'mailSmtpSslEnable',
        label: 'mail.smtp.ssl.enable',
        type: 'checkbox',
        showInList: true,
        required: true
      }
    ]
  },
  {
    name: 'passwordResetSubject',
    label: 'Subject for password reset',
    type: 'text',
    required:true
  },
  {
    name: 'passwordResetBody',
    label: 'Body for password reset',
    type: 'textarea',
    required:true
  },
  {
    name: 'currency',
    label: 'Currency',
    type: 'multiselect',
    isMulti: false,
    required:true,
    options: [
      { label: 'USD', value: 'usd' },
      { label: 'EUR', value: 'eur' },
      { label: 'GBP', value: 'gbp' },
      { label: 'JPY', value: 'jpy' },
      { label: 'AUD', value: 'aud' },
      { label: 'CAD', value: 'cad' },
      { label: 'CHF', value: 'chf' },
      { label: 'CNY', value: 'cny' },
      { label: 'SEK', value: 'sek' },
      { label: 'NZD', value: 'nzd' }
  ]},  
  {
    name: 'linkeinToken',
    label: 'LinkeIn Token',
    type: 'text',
    showInList: true,
    required: false
  },
  { name: 'logo',
    label: 'Logo',
    type: 'fileUploader',
    preview: true,
    showInList: false,
    required: false
  }
];

export default jsonSchema;
